(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maani-review-marquee')) {
  customElements.define('maani-review-marquee', class extends HTMLElement {
    connectedCallback() { this.classList.add('is-ready'); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
